import React from "react";

import clsx from "clsx";
import { FieldValues, Path, RegisterOptions, UseFormRegister } from "react-hook-form";


interface StyledTimeInputProps<T extends FieldValues> extends React.HTMLProps<HTMLInputElement> {
  register: UseFormRegister<T>;
  registerName: Path<T>;
  label?: string;
  registerOptions?: RegisterOptions<T, Path<T>>;
  colsClass?: string; // Tailwind CSS grid column classes
  classes?: string;
}

export function StyledTimeInput<T extends FieldValues>({
  register,
  registerName,
  label,
  registerOptions = {},
  disabled = false,
  colsClass = "sm:col-span-1",
  classes,
  ...rest
}: StyledTimeInputProps<T>) {

  const Input = () => <input
    {...register(registerName, registerOptions)}
    disabled={disabled}
    type="time"
    className={clsx(disabled ? "bg-gray-300" : "", "mt-1 w-full block shadow-sm focus:ring-etpink-500 focus:border-etpink-500 sm:text-sm border-gray-300 rounded-md", classes)}
    {...rest}
  />;

  if (colsClass !== "") {
    return (
      <div className={clsx(colsClass !== "" ? colsClass : "")}>
        {label && (
          <label className="text-sm font-medium text-gray-700">
            {label}
          </label>
        )}
        <Input />
      </div>
    )
  } else {
    return <div>
      {label && (
        <label className=" text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <Input />
    </div>
  }
}